export default {
  addCourse: () => `/courses`,
  updateCourse: () => `/courses`,
  searchCourses: searchTerm => `/courses?searchTerm=${searchTerm}`,
  getCourseById: id => `/courses/${id}`,
};
